/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-29 18:06:41
 * @LastEditTime: 2022-01-29 18:46:58
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 惠市宝对账单汇总列表->汇总数据订单明细数据->详情
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/HSBList/components/HSBInfoDetail.jsx
 */


import { Button, Modal } from 'antd';
import React, { useState } from 'react'
import { mapOrdrTpcd, mapRcnclRsltStcd } from '../../../../axios/dictionaries';
import { CustomCol, CustomRow } from '../../../../components/Custom';
import DetailTitle from '../../../../components/DetailTitle';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import { fetchPlatformRecordWftPayOrderSummaryDataOrderGet } from '../../../../services/platformAccountingRecord';
import { findDict, formatTime } from '../../../../utils';

const WFTInfoDetail = (props) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detailData, setDetailData] = useState({});
    const open = (id) => {
        setVisible(true)
        postGet(id)
    }
    const close = () => {
        setVisible(false)
    }
    const postGet = (id) => {
        setLoading(true)
        fetchPlatformRecordWftPayOrderSummaryDataOrderGet({id}).then(res => {
            setDetailData(res)
        }).finally(() => {
            setLoading(false)
        })
    }
    props.getRef && props.getRef({ open });
    return (
        <Modal
            title="对账详情"
            width={950}
            visible={visible}
            onCancel={close}
            footer={<Button onClick={close}>关闭</Button>}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }} loading={loading}>
                <div className="custom" >
                    <CustomRow divider>
                        <CustomCol label="交易金额">
                            <span style={{ paddingLeft:6 }}>{detailData.tradeAmount}</span>
                        </CustomCol>
                        <CustomCol label="手续比率">
                            <span style={{ paddingLeft:6 }}>{detailData.rate}</span>
                        </CustomCol>
                        <CustomCol label="手续费">
                            <span style={{ paddingLeft:6 }}>{detailData.serviceCharge}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="交易日期">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.tradeDateTime,'YYYY-MM-DD HH:mm:ss')}</span>
                        </CustomCol>
                        <CustomCol label="结算金额">
                            <span style={{ paddingLeft:6 }}>{ detailData.settlementAmount }</span>
                        </CustomCol>
                        <CustomCol label="商户名称" >
                            <span style={{ paddingLeft:6 }}>{detailData.merchantName}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="第三方商户号">
                            <span style={{ paddingLeft:6 }}>{detailData.thirdMchId}</span>
                        </CustomCol>
                        <CustomCol label="平台商户号">
                            <span style={{ paddingLeft:6 }}>{detailData.mchId}</span>
                        </CustomCol>
                        <CustomCol label="平台子商户号">
                            <span style={{ paddingLeft:6 }}>{detailData.subMchId}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="公众账号ID">
                            <span style={{ paddingLeft:6 }}>{detailData.appId}</span>
                        </CustomCol>
                        <CustomCol label="用户标识">
                            <span style={{ paddingLeft:6 }}>{detailData.openId}</span>
                        </CustomCol>
                        <CustomCol label="设备编号">
                            <span style={{ paddingLeft:6 }}>{detailData.deviceId}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="平台订单号">
                            <span style={{ paddingLeft:6 }}>{detailData.platformOrderNumber}</span>
                        </CustomCol>
                        <CustomCol label="第三方订单号">
                            <span style={{ paddingLeft:6 }}>{detailData.thirdPartyOrderNo}</span>
                        </CustomCol>
                        <CustomCol label="商户订单号">
                            <span style={{ paddingLeft:6 }}>{detailData.merchantOrderNumber}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="交易类型">
                            <span style={{ paddingLeft:6 }}>{detailData.transactionType}</span>
                        </CustomCol>
                        <CustomCol label="交易状态">
                            <span style={{ paddingLeft:6 }}>{detailData.transactionStatus}</span>
                        </CustomCol>
                        <CustomCol label="付款银行">
                            <span style={{ paddingLeft:6 }}>{detailData.payingBank}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="商品名称">
                            <span style={{ paddingLeft:6 }}>{detailData.goodName}</span>
                        </CustomCol>
                        <CustomCol label="商户数据包">
                            <span style={{ paddingLeft:6 }}>{detailData.merchantData}</span>
                        </CustomCol>
                    </CustomRow>
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}

export default WFTInfoDetail



// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/WFTList/components/WFTInfoDetail.jsx